<template>
	<div>
		<h1 class="view-title" data-v-step-delivery="1">
			ENTREGAS <span v-popover:tooltip.right="'Seção de gerenciamento das Entregas'"><i class="fas fa-question-circle"></i></span>
		</h1>
		<div class="inner-content shadowed">
			<div class="row">
				<div class="col-xs-12 col-lg-12">
					<div data-v-step-delivery="2">
						<button class="config-tab" :class="{ 'enabled': (filter == 'all') }" @click="filter_result('all')">
							TODOS
						</button>
						<button class="config-tab" :class="{ 'enabled': (filter == 'waiting') }" @click="filter_result('waiting')">
							<span class="waiting-color"><i class="fas fa-fw fa-circle"></i></span> AGUARDANDO
						</button>
						<button class="config-tab" :class="{ 'enabled': (filter == 'in_progress') }" @click="filter_result('in_progress')">
							<span class="in_progress-color"><i class="fas fa-fw fa-circle"></i></span> A CAMINHO
						</button>
						<button class="config-tab" :class="{ 'enabled': (filter == 'check_in') }" @click="filter_result('check_in')">
							<span class="check_in-color"><i class="fas fa-fw fa-circle"></i></span> ENTREGANDO
						</button>
						<button class="config-tab" :class="{ 'enabled': (filter == 'finished') }" @click="filter_result('finished')">
							<span class="finished-color"><i class="fas fa-fw fa-circle"></i></span> FINALIZADO
						</button>
						<button class="config-tab" :class="{ 'enabled': (filter == 'failed') }" @click="filter_result('failed')">
							<span class="failed-color"><i class="fas fa-fw fa-circle"></i></span> NÃO ENTREGUE
						</button>
						<button class="config-tab" :class="{ 'enabled': (filter == 'untracked') }" @click="filter_result('untracked')">
							<span class="untracked-color"><i class="fas fa-fw fa-circle"></i></span> DESVINCULADA
						</button>
					</div>
				</div>
			</div>
			<div class="inner-content-title">
				Lista <span v-popover:tooltip.right="'Lista de entregas cadastradas'"><i class="fas fa-question-circle"></i></span>
				<button class="btn-delivery" v-if="bulk_edit_list.length > 0 && filter == 'waiting'" @click="removeAll">
					<i class="fa fa-trash-alt"></i> REMOVER
				</button>
				<button class="btn-delivery" v-if="bulk_edit_list.length > 0 && filter == 'waiting'" @click="untrackedSelected">
					<i class="fa fa-times"></i> DESVINCULAR
				</button>
				<button class="btn-delivery" v-if="bulk_edit_list.length > 0 && filter == 'untracked'" @click="retrackedSelected">
					<i class="fa fa-check"></i> VINCULAR
				</button>
				<button class="btn-delivery" v-if="bulk_edit_list.length > 0 && filter == 'waiting'" @click="show_bulk_edit = true">
					<i class="fa fa-edit"></i> EDITAR
				</button>
				<button class="btn-delivery" @click="show_modal_cargo_status = true" :data-v-step-delivery="client_atak ? '8' : '7'">
					<i class="fas" :class="loading ? 'fa-circle-notch fa-spin': 'fa-boxes'"></i> ALTERAR STATUS
				</button>
				<button class="btn-delivery" @click="show_modal_sort = true" :data-v-step-delivery="client_atak ? '7' : '6'">
					<i class="fas" :class="loading ? 'fa-circle-notch fa-spin': 'fa-sort'"></i> ALTERAR SEQUÊNCIA
				</button>
				<span class="button-separator"></span>
				<button v-if="client_atak" class="btn-delivery" @click="show_modal_synchronization_atak = true" :data-v-step-delivery="client_atak ? '6' : ''">
					<i class="fas" :class="loading ? 'fa-circle-notch fa-spin': 'fa-sync'"></i> SINCRONIZAR
				</button>
				<button class="btn-delivery" @click="select_files" data-v-step-delivery="5">
					<i class="fas" :class="loading ? 'fa-circle-notch fa-spin': 'fa-upload'"></i> IMPORTAR
				</button>
				<button class="btn-delivery" @click="newDelivery" data-v-step-delivery="4">
					<i class="fas" :class="loading ? 'fa-circle-notch fa-spin': 'fa-plus'"></i> ADICIONAR
				</button>
				<button class="btn btn-link btn-right" @click="$refs.tour.editTour()" style="margin-top: 10px; margin-left: 15px;" data-v-step-delivery="3">
                    <i class="fas fa-question-circle"></i> TOUR
                </button>
			</div>
			<div class="row">
				<div class="col-xs-12 col-lg-12">
					<div class="container-filter">
						<div class="row">
							<div class="col-xs-12 col-lg-12 collapse-header" @click="show_filters = !show_filters">
								<div class="container-collapse-header" :data-v-step-delivery="client_atak ? '9' : '8'">
									<span><b><i class="fa fa-fw fa-sliders-h"></i> Filtros <span v-popover:tooltip.right="'Campos para filtragem do registro desejado'"><i class="fas fa-question-circle"></i></span></b></span>
									<span class="collapse-header-arrow" v-if="show_filters"><i class="fa fa-chevron-up"></i></span>
									<span class="collapse-header-arrow" v-else><i class="fa fa-chevron-down"></i></span>
								</div>
							</div>
							<div v-if="show_filters" class="col-xs-12 col-lg-12 container-collapse-body">
								<div class="collapse-body">
									<div class="row">
										<div class="col-xs-12 col-lg-6">
											<FormSelect v-model="filters.company_document" label="Emissor" :options="options.company_document" :multiple="true" :required="false" ref="company_document_filter" tooltip="Selecione o emissor das entregas" />
										</div>
										<div class="col-xs-12 col-lg-6">
											<FormSelect v-model="filters.customer_id" label="Cliente" :options="options.customer_id" :multiple="true" :required="false" ref="customer_id_filter" tooltip="Selecione o cliente desejado" />
										</div>
										<div v-if="client_atak && (Object.keys(options.dc).length > 0)" class="col-xs-12 col-lg-3">
											<FormSelect v-model="filters.dc" label="Centro de Distribuição" :options="options.dc" :multiple="true" :required="false" ref="dc_filter" tooltip="Selecione o local de estoque desejado" />
										</div>
										<div class="col-xs-12 col-lg-2">
											<FormSelect v-model="filters.type" label="Tipo" :options="options.type" :multiple="true" :required="false" ref="type_filter" tooltip="Selecione o tipo da entrega desejada" />
										</div>
										<div class="col-xs-12 col-lg-2">
											<FormInput v-model="filters.document_number" label="Número" type="text" :required="false" ref="document_number_filter"  tooltip="Informe o número da entrega desejada" />
										</div>
										<div class="col-xs-12 col-lg-2">
											<FormInputMasked v-model="filters.postal_code" label="CEP" type="text" :required="false" mask="#####-###" ref="address_postal_code_filter" tooltip="Informe o CEP desejado" />
										</div>
										<div class="col-xs-12 col-lg-3">
											<FormInput v-model="filters.street" label="Logradouro" type="text" :required="false" ref="address_street_filter" tooltip="Informe o logradouro desejado" />
										</div>
										<div class="col-xs-12 col-lg-3">
											<FormInput v-model="filters.neighborhood" label="Bairro" type="text" :required="false" ref="address_neighborhood_filter" tooltip="Informe o bairro desejado" />
										</div>
										<div class="col-xs-12 col-lg-4">
											<FormSelect v-model="filters.city" label="Cidade" :options="options.city" :multiple="true" :required="false" :loading="loading" ref="address_city_filter" tooltip="Informe a cidade desejada" />
										</div>
										<div class="col-xs-12 col-lg-2">
											<FormSelect v-model="filters.uf" label="UF" :options="options.uf" :multiple="true" :required="false" ref="address_uf_filter" tooltip="Selecione a UF desejada" />
										</div>
										<div class="col-xs-12 col-lg-3">
											<FormSelect v-model="filters.license_plate" label="Veículo" :options="options.license_plate" :multiple="true" :required="false" :loading="loading" ref="license_plate_filter" tooltip="Selecione o veículo desejado" />
										</div>
										<div class="col-xs-12 col-lg-3">
											<FormSelect v-model="filters.driver_document" label="Motorista" :options="options.driver_document" :multiple="true" :required="false" :loading="loading" ref="driver_document_filter" tooltip="Selecione o motorista desejado" />
										</div>
										<div class="col-xs-12 col-lg-3">
											<FormSelect v-model="filters.cargo" label="Carga" :options="options.cargo" :multiple="false" :required="false" :loading="loading" ref="cargo_filter" tooltip="Selecione a carga desejada" />
										</div>
										<div v-if="client_atak" class="col-xs-12 col-lg-3">
											<FormSelect v-model="filters.cargo_external" label="Carga externa" :options="options.cargo_external" :multiple="false" :required="false" :loading="loading" ref="cargo_filter" tooltip="Selecione a carga externa desejada" />
										</div>
										<div class="col-xs-12 col-lg-3">
											<FormInput v-model="filters.start" label="Data de entrega inicial" type="date" :required="false" ref="start_filter" tooltip="Informe a data de entrega inicial desejada" />
										</div>   
										<div class="col-xs-12 col-lg-3">
											<FormInput v-model="filters.end" label="Data de entrega final" type="date" :required="false" ref="end_filter" tooltip="Informe data de entrega final desejada" />
										</div>
										<div v-if="client_atak" class="col-xs-12 col-lg-2">
											<FormSelect v-model="filters.temperature" label="Temperatura" :options="options.temperature" :multiple="true" :required="false" ref="temperature_filter" tooltip="Selecione a temperatura desejada" />
										</div>
										<div v-if="client_atak" class="col-xs-12 col-lg-2">
											<FormSelect v-model="filters.bone" label="Osso" :options="options.bone" :multiple="true" :required="false" ref="bone_filter" tooltip="Selecione a característica desejada" />
										</div>
										<div class="col-xs-12 col-lg-2">
											<FormCheckbox v-model="filters.no_weight_zero" label="Desconsiderar peso zerado" ref="no_weight_zero_filter" tooltip="Informe a filtragem de peso desejada" />
										</div>
										<div class="col-xs-12 col-lg-1">
											<FormSelect v-model="per_page" label="Exibir" :options="options.per_page" ref="per_page_filter" tooltip="Selecione a quantidade a ser exibida" />
										</div>
									</div>
									<div class="row">
										<div class="col-xs-12 col-lg-2">
											<button class="add_new_filters" @click="filter_deliveries()">
												<i class="fas fa-filter"></i> Filtrar
											</button>
										</div>
										<div class="col-xs-12 col-lg-2">
											<button class="add_new_filters" @click="clean_filters()">
												<i class="fas fa-eraser"></i> Limpar
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-lg-12">
					<Table 
						:loading="loading"
						:headers="headers" 
						:ordering="ordering" 
						:order="order"
						@reorder="(o) => { order = o; load(); }"
						:list="list" 
						:page="page"
						:per_page="per_page" 
						:total="total" 
						:modifiers="modifiers" 
						@next="() => { page++; load(); }" 
						@prev="() => { page--; load(); }"
						:on_select="((filter == 'waiting') || (filter == 'untracked')) ? bulk_edit_add : undefined"
						:selected="bulk_edit_list"
						v-slot="{item}"
						:data-v-step-delivery="client_atak ? '10' : '9'"
					>
						<button class="button-edit" title="Ver detalhes" @click="openData(item, 'detail')">
							<i class="fa fa-fw fa-list"></i>
						</button>
						<button v-if="(item.type == 1) && (item.status == 'waiting')" class="button-edit"  title="Editar entrega" @click="editDelivery(item)">
							<i class="fa fa-fw fa-edit"></i>
						</button>
						<button v-if="((item.status == 'waiting') || (item.status == 'in_progress') || (item.status == 'in_progress' && item.checkin_date))" class="button-edit" title="Editar status"  @click="openModalStatus(item)">
							<i class="fa fa-fw fa-box"></i>
						</button>
						<button v-if="((item.status == 'in_progress') || (item.status == 'in_progress' && item.checkin_date) || (item.status == 'finished') || (item.status == 'failed')) && item.delivery_evidence" class="button-edit" title="Ver evidências"  @click="openMapEvidence(item)">
							<i class="fa fa-fw fa-camera"></i>
						</button>
						<button v-if="item.payment_id" class="button-edit" title="Ver pagamento" @click="openData(item, 'payment')">
							<i class="fa fa-fw fa-credit-card"></i>
						</button>
						<button v-if="(item.status == 'finished') || (item.status == 'failed')" class="button-edit"  title="Ver rota" @click="openMap(item)">
							<i class="fa fa-fw fa-truck"></i>
						</button>
						<button v-if="(item.status == 'waiting') || (item.status == 'untracked')" class="button-remove" @click="remove(item.id)" title="Remover entrega">
							<i class="fa fa-fw fa-trash"></i>
						</button>
					</Table>
				</div>
			</div>
		</div>
		<DeliveryData v-if="show_modal_data"
			:current_data="current"
			:current_tab="tab"

			@close="show_modal_data = false"
		/>
		<DeliveryBulkEdit v-if="show_bulk_edit"
			:list="bulk_edit_list"
			:show="show_bulk_edit"
			:drivers="optionsDriverReduced()"
		/>
		<DeliverySort v-if="show_modal_sort"
			:my_drivers_reduced="optionsDriverReduced()"
			:show="show_modal_sort"
		/>
		<DeliveryCargoStatus v-if="show_modal_cargo_status"
			:cargo="options.cargo"
			@close="closeModalCargoStatus()"
		/>
		<DeliveryStatus v-if="show_modal_status"
			:current="current"
			@close="closeModalStatus()"
		/>
		<DeliveryEvidence v-if="show_modal_map_evidence"
			:current="current"
			@close="closeMapEvidence()"
			ref="DeliveryEvidence"
		/>
		<DeliveryRoute v-if="show_modal_map_route"
			:delivery="current_delivery_route"
			:driver="current_driver_route"
			:settings="settings"
			@close="closeMap()"
			ref="DeliveryRoute"
		/>
		<DeliveryForm v-if="show_modal_form"
			:current="current_form"
			:my_customers="my_customers"
			:my_documents="my_documents"
			:my_drivers="my_drivers"
		/>
		<DeliverySynchronizationAtak v-if="show_modal_synchronization_atak"
			:integration="settings.integration"
			:url_api_atak="settings.url_api_atak"
			:default_customer_sync_name="settings.default_customer_sync_name"
			:default_moviment_type_code="settings.default_moviment_type_code"
		/>
		<DeliveryImport v-if="show_modal_import"
			:files="uploading"
			@update="updateFiles"
		/>
		<input ref="upload_input" type="file" multiple="multiple" accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/plain, text/xml" style="display: none;" @change="upload_files" />
		
		<Tour
            tour="Delivery"
            :steps="tour_steps"
			:callbackOnFinish="true"
			ref="tour"
        />
	</div>
</template>

<script>
import Api from "@/lib/Api";

import FormCheckbox from "@/components/FormCheckbox.vue";
import FormInput from "@/components/FormInput";
import FormInputMasked from "@/components/FormInputMasked";
import FormSelect from "@/components/FormSelect";
import DeliveryBulkEdit from "./Delivery/DeliveryBulkEdit";
import DeliveryData from "./Delivery/DeliveryData";
import DeliveryEvidence from "./Delivery/DeliveryEvidence";
import DeliveryForm from "./Delivery/DeliveryForm";
import DeliveryImport from "./Delivery/DeliveryImport";
import DeliveryRoute from "./Delivery/DeliveryRoute";
import DeliverySort from "./Delivery/DeliverySort";
import DeliveryCargoStatus from "./Delivery/DeliveryCargoStatus";
import DeliveryStatus from "./Delivery/DeliveryStatus";
import DeliverySynchronizationAtak from "./Delivery/DeliverySynchronizationAtak";
import Table from "@/components/Table";
import Tour from "@/components/Tour";

const status = {
	no_delivery: {
		color: "#aaa",
		status: "Nenhuma entrega",
	},
	waiting: {
		color: "#555",
		status: "Aguardando",
	},
	in_progress: {
		color: "#005ef7",
		status: "A caminho",
	},
	check_in: {
		color: "#ffb300",
		status: "Entregando",
	},
	finished: {
		color: "#008000",
		status: "Finalizado",
	},
	failed: {
		color: "#ff0000",
		status: "Não entregue",
	},
	untracked: {
		color: "#eee",
		status: "Desvinculada",
	},
};

export default {
	name: "Delivery",

	components: {
		FormCheckbox,
		FormInput,
		FormInputMasked,
		FormSelect,
		DeliveryBulkEdit,
		DeliveryData,
		DeliveryEvidence,
		DeliveryForm,
		DeliveryImport,
		DeliveryRoute, 
		DeliverySort,
		DeliveryCargoStatus,
		DeliveryStatus,
		DeliverySynchronizationAtak,
		Table,
		Tour,
	},
	
	data: function() {
		let filter = window.localStorage.getItem('Delivery.filter');
		if (!filter) {
			filter = 'all';
		}

		let steps = [
			{
				target: '[data-v-step-delivery="0"]',
				header: {
					title: '<code>SEÇÃO ENTREGAS</code>',
				},
				content: '<code>Clique no menu <b>ENTREGAS</b> para ir a seção de listagem e gerenciamento das entregas cadastradas</code>',
				params: {
					placement: 'right',
					highlight: false,
				}
			},
			{
				target: '[data-v-step-delivery="1"]',
				header: {
					title: '<code>SEÇÃO ATUAL</code>',
				},
				content: '<code>Identifique pelo título a seção que está atualmente</code>',
				params: {
					placement: 'bottom',
					highlight: true,
				}
			},
			{
				target: '[data-v-step-delivery="2"]',
				header: {
					title: '<code>ABAS DE STATUS</code>',
				},
				content: '<code>Clique nas <b>ABAS DE STATUS</b> para filtrar rapidamente a listagem de entregas por status atual</code>',
				params: {
					placement: 'bottom',
					highlight: true,
				}
			},
			{
				target: '[data-v-step-delivery="3"]',
				header: {
					title: '<code>TOUR</code>',
				},
				content: '<code>Em caso de dúvida clique no botão <b>TOUR</b> para gerenciar a exibição do tour nessa seção, e assim ter um auxílio referente aos elementos da página</code>',
				params: {
					placement: 'left',
					highlight: true,
				}
			},
			{
				target: '[data-v-step-delivery="4"]',
				header: {
					title: '<code>ADICIONAR</code>',
				},
				content: '<code>Clique em <b>ADICIONAR</b> para abrir o formulário de cadastro manual de uma nova entrega</code>',
				params: {
					placement: 'left',
					highlight: true,
				}
			},
			{
				target: '[data-v-step-delivery="5"]',
				header: {
					title: '<code>IMPORTAR</code>',
				},
				content: '<code>Clique em <b>IMPORTAR</b> para abrir o formulário de importação entrega a partir de arquivos (.csv, .txt, .xls, .xlsx ou .xml)</code>',
				params: {
					placement: 'left',
					highlight: true,
				}
			},
		];
		if (this.$api.user.company_client_atak) {
			steps = steps.concat([
				{
                    target: '[data-v-step-delivery="6"]',
                    header: {
                        title: '<code>SINCRONIZAR</code>',
                    },
                    content: '<code>Clique em <b>SINCRONIZAR</b> para abrir o formulário de sincronização de pedidos com o sistema integrado</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
				{
					target: '[data-v-step-delivery="7"]',
					header: {
						title: '<code>ALTERAR SEQUÊNCIA</code>',
					},
					content: '<code>Clique em <b>ALTERRAR SEQUÊNCIA</b> para abrir o formulário de alteração de sequência da uma determinada carga</code>',
					params: {
						placement: 'left',
						highlight: true,
					}
				},
				{
					target: '[data-v-step-delivery="8"]',
					header: {
						title: '<code>ALTERAR STATUS</code>',
					},
					content: '<code>Clique em <b>ALTERAR STATUS</b> para editar os status das entregas de uma carga</code>',
					params: {
						placement: 'left',
						highlight: true,
					}
				},
                {
                    target: '[data-v-step-delivery="9"]',
                    header: {
                        title: '<code>FILTRAGEM</code>',
                    },
                    content: '<code>Campos de filtragem das entregas</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-delivery="10"]',
                    header: {
                        title: '<code>ENTREGAS</code>',
                    },
                    content: '<code>Lista dos registros de entregas cadastradas</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ]);
		} else {
			steps = steps.concat([
				{
					target: '[data-v-step-delivery="6"]',
					header: {
						title: '<code>ALTERAR SEQUÊNCIA</code>',
					},
					content: '<code>Clique em <b>ALTERRAR SEQUÊNCIA</b> para abrir o formulário de alteração de sequência da uma determinada carga</code>',
					params: {
						placement: 'left',
						highlight: true,
					}
				},
				{
					target: '[data-v-step-delivery="7"]',
					header: {
						title: '<code>ALTERAR STATUS</code>',
					},
					content: '<code>Clique em <b>ALTERAR STATUS</b> para editar os status das entregas de uma carga</code>',
					params: {
						placement: 'left',
						highlight: true,
					}
				},
                {
                    target: '[data-v-step-delivery="8"]',
                    header: {
                        title: '<code>FILTRAGEM</code>',
                    },
                    content: '<code>Campo de filtragem das entregas</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-delivery="9"]',
                    header: {
                        title: '<code>ENTREGAS</code>',
                    },
                    content: '<code>Lista dos registros de entregas cadastradas</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ]);
		}

		// Colunas exibidas conforme a empresa ser cliente atak
		let headers = {};
		let ordering = []
		if (this.$api.user.company_client_atak) {
			headers = {
				document_number: "Número",
				type: "Tipo",
				date: "Data entrega",
				company_name: "Emissor",
				customer_name: "Cliente",
				license_plate: "Veículo",
				driver_name: "Motorista",
				cargo: "Carga (Seq.)",
				cargo_external: "Carga externa (Seq.)",
			};
			ordering = ['document_number', 'date', 'driver_name', 'cargo', 'cargo_external'];
		} else {
			headers = {
				document_number: "Número",
				type: "Tipo",
				date: "Data entrega",
				company_name: "Emissor",
				customer_name: "Cliente",
				license_plate: "Veículo",
				driver_name: "Motorista",
				cargo: "Carga (Seq.)",
			};
			ordering = ['document_number', 'date', 'driver_name', 'cargo'];
		}

		return {
			loading: false,

			// Tabela
			headers: headers,
			ordering: ordering,
			order: 'date-DESC',
			list: [],
			page: 0,
			per_page: 25,
			total: 0,
			modifiers: {
				document_number: function(d, item) {
					let current_status = "waiting";

					if ((item.status == "in_progress") && (item.checkin_date != null) && (item.checkin_location != null)) {
						current_status = "check_in";
					} else {
						current_status = item.status;
					}

					return `
						<i class="fa fa-fw fa-circle" style="color: ${status[current_status].color}" title="${status[current_status].status}"></i>
						<b title='ID: ${item.id}'>${d}</b>
					`;
				},
				type: function(d) {
                    if (d == 0) {
                        return "<span title='Nota Fiscal'>Nota Fiscal</span>";
                    } else {
                        return "<span title='Pedido'>Pedido</span>";
                    }
				},
				date: function(d) {
					const date = d.split("-").reverse();
					//date[2] = date[2].substr(2, 2);
					return date.join("/");
				},
				company_name: function(d) {
					if (d.length > 15) {
						return `<span class="capitalized" title="${d}">${d.toLowerCase().slice(0, 15)}...</span>`;
					} else {
						return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
					}
				},
				license_plate: function(d) {
					let str = "";
					let color = "";

					if (d) { 
						str = d;
					} else {
						str = "Não Definido";
						color = "color: #aaa";
					}

					return `<span class="capitalized" title="${str}" style="${color}">${str}</span>`;
				},
				driver_name: function(d, item) {
					let last_access = "Ainda não acessado pelo motorista";
					//let decor = '';
					let str = "";
					let color = "";
					
					if (item.last_access != null) {
						let splitted = item.last_access.split(" ");
						let date = splitted[0].split('-');
						let time = splitted[1].split(':');

						last_access = "Último acesso pelo motorista: " + date[2] + "/" + date[1] + " às " + time[0] + ":" + time[1] + "h";
						//decor = "text-decoration: underline;";
					}

					if (d) { 
						str = d.toLowerCase();
					} else {
						str = "Não Definido";
						color = "color: #aaa";
					}

					if (d.length > 15) {
						return `<span class="capitalized" title="${last_access}" style="${color}">${str.slice(0, 15)}...</span>`;
					} else {
						return `<span class="capitalized" title="${last_access}" style="${color}">${str}</span>`;
					}
				},
				cargo: function(d, item) {
					let str = "";
					let color = "";

					if (d) { 
						str = d;
					} else {
						str = "Não definida";
						color = "color: #aaa";
					}

					if (item.sequence) str += ` <b title="Sequência">(${item.sequence})</b>`;

					return `<span title="${d}" style="${color}">${str}</span>`;
				},
				cargo_external: function(d, item) {
					let str = "";
					let color = "";

					if (d) { 
						str = d;
					} else {
						str = "Não definida";
						color = "color: #aaa";
					}

					if (item.sequence) str += ` <b title="Sequência">(${item.sequence})</b>`;

					return `<span title="${d}" style="${color}">${str}</span>`;
				},
				customer_name: function(d) {
					let str = "";
					let color = "";

					if (d) { 
						str = d.toLowerCase();
					} else {
						str = "Não definido";
						color = "color: #aaa";
					}
					
					if (str.length > 15) {
						return `<span class="capitalized" title="${str}" style="${color}">${str.slice(0, 15)}...</span>`;
					} else {
						return `<span class="capitalized" title="${str}" style="${color}">${str}</span>`;
					}
				}
			},
			select_all: false,

			cities_list: [],

			// Filtros
			filter: filter,
			filter_driver: false,
			filter_cargo: false,

			filters: {
                company_document: [],
                customer_id: [],
                dc: [],
				type: [],
				document_number: "",
                postal_code: "",
                street: "",
                neighborhood: "",
                city: [],
                uf: [],
				license_plate: [],
				driver_document: [],
				cargo: [],
				cargo_external: [],
                start: "",
                end: "",
                temperature: [],
                bone: [],
                no_weight_zero: false,
            },
			options: {
				company_document: {},
				customer_id: {},
				dc: {},
				type: {
					"0": "NOTA FISCAL",
					"1": "PEDIDO",
				},
				city: {},
                uf: {
					'AC': 'AC',
					'AL': 'AL',
					'AP': 'AP',
					'AM': 'AM',
					'BA': 'BA',
					'CE': 'CE',
					'DF': 'DF',
					'ES': 'ES',
					'GO': 'GO',
					'MA': 'MA',
					'MT': 'MT',
					'MS': 'MS',
					'MG': 'MG',
					'PA': 'PA',
					'PB': 'PB',
					'PR': 'PR',
					'PE': 'PE',
					'PI': 'PI',
					'RJ': 'RJ',
					'RN': 'RN',
					'RS': 'RS',
					'RO': 'RO',
					'RR': 'RR',
					'SC': 'SC',
					'SP': 'SP',
					'SE': 'SE',
					'TO': 'TO'
				},
				license_plate: {},
				driver_document: {},
				cargo: {},
				cargo_external: {},
                temperature: {
                    "0": "AMBIENTE",
                    "2": "CONGELADO",
                    "1": "RESFRIADO",
                },
                bone: {
                    "0": "COM OSSO",
                    "1": "SEM OSSO",
                },
				per_page: {
					25: "25",
					50: "50",
					75: "75",
					100: "100",
				}
            },
			show_filters: false,

			// Cadastro Edição
			current_form: null,
			show_modal_form: false,

			// Upload
			formats: [
				".csv",
				"application/vnd.ms-excel",
				"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
				"text/plain", 
				"text/xml"
			],
			uploading: [],
			results: [],
			
			// Rota
			current_delivery_route: null,
			current_driver_route: null,
			show_modal_map_route: false,

			// Seleção
			bulk_edit_list: [],
			show_bulk_edit: false,

			// Controle dos deais modais
			show_modal_synchronization_atak: false,
			show_modal_import: false,
			show_modal_cargo_status: false,
			show_modal_status: false,

			current: null,
			show_modal_data: false,
			show_modal_map_evidence: false,
			tab: 'detail',
			show_modal_sort: false,

			my_customers: {},
			my_documents: {},
			my_drivers: {},
			settings: {},
			
			// Opção atak
			client_atak: this.$api.user.company_client_atak,
			
            tour_steps: steps,
		}
	},

	beforeCreate: function() {
        if (!this.$api.user.is_admin) {
            let permissions = this.$api.user.permissions.split(",");
            if (!permissions.includes("Delivery")) {
                this.$router.push({ name: 'Home' });
            }
        }
	},
	
	mounted: async function() {
		this.loading = true;
		if (this.$route.params.filter_driver) {
			this.filter = 'all';
			this.filters.driver_document = this.$route.params.filter_driver;
		}
		
		if (this.$route.params.filter_cargo) {
			this.filters.cargo = this.$route.params.filter_cargo;
		}
		
		if (this.client_atak) {
			await this.loadSettings();
			this.loadCargoExternal();
		}
		this.$refs.tour.setTour();
		this.loadCargo();
		this.loadCity();
		this.loadCustomerDocument();
		this.loadDc();
		this.loadCompanyDocument();
		this.loadDriverDocument();
		this.loadLicensePlate();
		await this.load();
		this.loading = false;
	},

	activated: async function() {
		this.loading = true;
		if (this.client_atak) {
			await this.loadSettings();
			this.loadCargoExternal();
		}
		this.loadCargo();
		this.loadCity();
		this.loadCustomerDocument();
		this.loadDc();
		this.loadCompanyDocument();
		this.loadDriverDocument();
		this.loadLicensePlate();
		await this.load();
		this.loading = false;
	},

	methods: {
		filter_result: function(status) {
			window.localStorage.setItem('Delivery.filter', status);
			this.filter = status;
			this.page = 0;
			this.per_page = 50;
			this.bulk_edit_list = [];
			this.load();
		},

		loadCargo: async function() {
			let result = null;
			try {
				result = await Api.post("delivery/list-my-cargos");
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as informações de cargas.");
				return;
			}

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.options.cargo = this.optionsCargo(result.data);
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter todas as informações de cargas.");
				return;
			}
		},

		loadCargoExternal: async function() {
			let result = null;
			try {
				result = await Api.post("delivery-routing/list-my-cargos-external");
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as informações de cargas externas.");
				return;
			}

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.options.cargo_external = this.optionsCargoExternal(result.data);
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter todas as informações de cargas externas.");
				return;
			}
		},

		// Carrega a lista de cidades
        loadCity: async function() {
			let result = null;
			try {
				result = await Api.post("delivery/list-my-cities");
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as informações de cidades.");
				return;
			}
			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.options.city = this.optionsCity(result.data);
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter todas as informações de cidades.");
				return;
			}
		},

		// Carrega a lista de filiais
        loadCompanyDocument: async function() {
            let result = null;
            try {
                result = await Api.post("delivery/list-my-documents");
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter todas as informações de filiais.");
                return;
            }

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.my_documents = result.data;
					this.options.company_document = this.optionsCompanyDocument(result.data);
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter todas as informações de filiais.");
                return;
			}
		},
        
        // Carrega a lista de clientes
        loadCustomerDocument: async function() {
			let result = null;
			try {
				result = await Api.post("customer/list-my-customers");
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as informações de clientes.");
				return;
			}

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.my_customers = result.data;
					this.options.customer_id = this.optionsCustomerDocument(result.data);
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter todas as informações de clientes.");
				return;
			}
		},

        // Obtém a lista de centros
        loadDc: async function() {
            let result = null;
            try {
                result = await Api.post("distribution-center/list-my-dcs");
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter todas as informações de centros de distribuição.");
                return;
            }

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.options.dc = this.optionsDc(result.data);
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter todas as informações de centros de distribuição.");
                return;
			}
        },
        
        // Carrega a lista de motoristas
		loadDriverDocument: async function() {
			let result = null;
			try {
				result = await Api.post("driver/list-my-drivers");
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as informações de motoristas.");
				return;
			}

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.my_drivers = result.data;
					this.options.driver_document = this.optionsDriverDocument(result.data);
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter todas as informações de motoristas.");
				return;
			}
		},
        
		// Carrega a lista de veículos
        loadLicensePlate: async function() {
            let result = null;
            try {
                result = await Api.post("vehicle/list-my-vehicles");
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter todas as informações de veículo.");
                return;
            }

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.options.license_plate = this.optionsLicensePlate(result.data);
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter todas as informações de veículo.");
                return;
			}
		},

		// Obtém as configurações padrão
        loadSettings: async function() {
            let result = null;
            try {
                result = await Api.post("config/list-my-settings");
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter todas as informações de configuração.");
                return;
            }

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.settings = Object.assign({}, result.data);
					return;
				}
            } else {
				this.$notification.error("Não foi possível obter todas as informações de configuração.");
                return;
			}
        },

		optionsCargo: function(cargos) {
			let r = {};
			cargos.map(c => {
				r[c.cargo] =  c.cargo;
			});
			return r;
		},
		
		optionsCargoExternal: function(cargos) {
			let r = {};
			cargos.map(c => {
				r[c.cargo_external] =  c.cargo_external;
			});
			return r;
		},

        optionsCity: function(cities) {
			let r = {};
			cities.map(c => {
                let city = c.city.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase();
                if (typeof r[city] !== "undefined") {
                    let cities_aux = this.cities_list[city];
                    if (!cities_aux.includes(c.city)) this.cities_list[city].push(c.city);
                } else {
                    r[city] = city;
                    this.cities_list[city] = [c.city];
                }
			});
			return r;
		},

		optionsCustomerDocument: function(customers) {
			let r = {};
			customers.map(c => {
				r[c.id] = c.name.toUpperCase() + " - " + (c.document.length > 11 ? c.document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : c.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"));
			});
			return r;
		},

        optionsDc: function(dcs) {
			let r = {};
			dcs.map(d => {
                if (d.code) r[d.code] = d.name;
			});
			return r;
		},

		optionsCompanyDocument: function(documents) {
			let r = {};
			documents.map(d => {
				r[d.document] = d.name.toUpperCase() + " - " + d.document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
			});
			return r;
		},

		optionsDriverDocument: function(drivers) {
			let r = {};
			drivers.map(d => {
				r[d.document] = d.name.toUpperCase() + " - " + d.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
			});
			return r;
		}, 

		optionsDriverReduced: function() {
			let r = {};
			this.my_drivers.map(d => {
				r[d.document] = d.name.toUpperCase() + " - " + d.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
			});
			return r;
		}, 
		
		optionsLicensePlate: function(vehicles) {
			let r = {};
			vehicles.map(v => {
				r[v.license_plate] = v.license_plate;
			});
			return r;
		}, 

		// Carrega a lista com os registros
        load: async function() {
            let form = {};
            
            this.list = [];
			this.total = 0;
            
			form.filters = this.filters;
			if (this.filters.city.length > 0) {
                let cities_array = [];
                this.filters.city.forEach(city => {
                    cities_array = cities_array.concat(this.cities_list[city]);
                });
                form.filters.city = cities_array;
            }
			form.filters.status = this.filter;
            form.order = this.order;
            form.page = this.page;
            form.per_page = this.per_page;
            
            // Requisita as informações
            let result = null;
            this.loading = true;
            try {
                result = await Api.post("delivery/list", form);
            } catch (ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter a lista de entregas.");
                this.loading = false;
                return;
            }
			this.loading = false;

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.list = result.data;
					this.total = result.total;
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter a lista.");
				return;
			}
		},

		filter_deliveries: function() {
			this.page = 0;
            this.load();
        },

		clean_filters: function() {
            this.filters.company_document = [];
            this.$refs.company_document_filter.clear_selected();
            this.filters.customer_id = [];
            this.$refs.customer_id_filter.clear_selected();
            this.filters.dc = [];
            this.$refs.dc_filter.clear_selected();
			this.filters.type = "";
            this.$refs.type_filter.clear_selected();
            this.filters.document_number = "";
            this.filters.postal_code = "";
            this.filters.street = "";
            this.filters.neighborhood = "";
            this.filters.city = [];
            this.$refs.address_city_filter.clear_selected();
            this.filters.uf = [];
            this.$refs.address_uf_filter.clear_selected();
			this.filters.license_plate = [];
            this.$refs.license_plate_filter.clear_selected();
			this.filters.driver_document = [];
            this.$refs.driver_document_filter.clear_selected();
			this.filters.cargo = [];
            this.$refs.cargo_filter.clear_selected();
			this.filters.start = "";
            this.$refs.start_filter.update("");
			this.filters.end = "";
            this.$refs.end_filter.update("");
            this.filters.temperature = [];
            this.$refs.temperature_filter.clear_selected();
            this.filters.bone = [];
            this.$refs.bone_filter.clear_selected();
            this.filters.no_weight_zero = false;
        },
		
		select_files: function() {
			this.$refs.upload_input.click();
		},
		
		// Adiciona lista de arquivos
		upload_files: async function() {
			if (Array.isArray(this.$refs.upload_input.files)) {
				if ((this.$refs.upload_input.files.length > 0) && (this.$refs.upload_input.files.length <= 10)) {
					this.$refs.upload_input.files.forEach(file => {
						if (this.formats.indexOf(file.type) == -1 ) {
							this.$notification.error("O arquivo " + file.name + " não é de extensão válida (.csv, .xls, .xlsx, .xml ou .txt).");
						} else {
							let find = this.uploading.find(element => element.name == file.name);
							if (typeof find == "undefined") {
								this.uploading.push(file);
							}
						}
					});
				} else {
					this.show_modal_import = false;
					this.$notification.error("Por favor, importe até 10 arquivos por vez.");
					return;	
				}
			} else {
				if ((Object.keys(this.$refs.upload_input.files).length > 0) && (Object.keys(this.$refs.upload_input.files).length <= 10)) {
					Object.keys(this.$refs.upload_input.files).forEach(file => {
						if (this.formats.indexOf(this.$refs.upload_input.files[file].type) == -1 ) {
							this.$notification.error("O arquivo " + this.$refs.upload_input.files[file].name + " não é de extensão válida (.csv, .xls, .xlsx, .xml ou .txt).");
						} else {
							let find = this.uploading.find(element => element.name == this.$refs.upload_input.files[file].name);
							if (typeof find == "undefined") {
								this.uploading.push(this.$refs.upload_input.files[file]);
							}
						}
					});
				} else {
					this.show_modal_import = false;
					this.$notification.error("Por favor, importe até 10 arquivos por vez.");
					return;	
				}
			}

			if (Object.keys(this.uploading).length == 0) {
				this.$notification.error("Por favor, importe arquivos válidos (.csv, .xls, .xlsx, .xml ou .txt).");
				return;
			}

			this.show_modal_import = true;
		},		

		bulk_edit_add: function(id) {
			if (id == 'all') return this.bulk_edit_add_all();

			if (this.bulk_edit_list.includes(id)) {
				const index = this.bulk_edit_list.indexOf(id);
				if (index !== false) {
					this.bulk_edit_list.splice(index, 1);
					this.select_all = false;
				}
			} else {
				this.bulk_edit_list.push(id);
			}
		},

		bulk_edit_add_all: function() {
			this.select_all = !this.select_all;

			for (let i = 0; i < this.list.length; i++) {
				if (this.select_all) {
					if (!this.bulk_edit_list.includes(this.list[i].id)) {
						this.bulk_edit_list.push(this.list[i].id);
					}
				} else {
					if (this.bulk_edit_list.includes(this.list[i].id)) {
						let index = this.bulk_edit_list.indexOf(this.list[i].id);
						if (index !== false) {
							this.bulk_edit_list.splice(index, 1);
						}
					}
				}
			}
		},

		// Formata o tipo
		toType: function(type) {
			if (type == 0) {
				return "Nota Fiscal";
			} else {
				return "Pedido";
			}
		},

		// Formata a data
		toDate: function(date) {
			let dateAux = date.split("-");
			return dateAux[2] + "/" + dateAux[1] + "/" + dateAux[0];
		},
		
		// Formata o valor em dinheiro
		toMoney: function(money) {
			let moneyAux = money.replace(",", ".").split(".");
			if(moneyAux.length > 1) {
				if (moneyAux[1].length > 1) {
					return "R$ " + moneyAux[0] + "," + moneyAux[1];
				} else {
					return "R$ " + moneyAux[0] + "," + moneyAux[1] + "0";
				}
			} else {
				return "R$ " + moneyAux[0] + ",00";
			}
		},

		untrackedSelected: async function() {
			const confirm = await this.$alert.confirm("Deseja mesmo desvincular as entregas selecionadas?");
			if (!confirm) return;

			let form = {
				selected: this.bulk_edit_list
			};

			this.loading = true;
			let res = await Api.post("delivery/untracked", form);
			this.loading = false;
			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.load();
			this.bulk_edit_list = [];
		},
		
		retrackedSelected: async function() {
			const confirm = await this.$alert.confirm("Deseja mesmo vincular novamente as entregas selecionadas?");
			if (!confirm) return;

			let form = {
				selected: this.bulk_edit_list
			};

			this.loading = true;
			let res = await Api.post("delivery/retracked", form);
			this.loading = false;
			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.load();
			this.bulk_edit_list = [];
		},

		openData: function(item, tab) {
			this.current = item;
			this.tab = tab;
			this.show_modal_data = true;
		},

		openMapEvidence: function(item) {
			this.current = item;
			this.show_modal_map_evidence = true;
		},

		closeMapEvidence: function() {
			this.current = null;
			this.show_modal_map_evidence = false;
		},

		openMap: function(item) {
			this.current_delivery_route = item;
			this.current_driver_route = this.my_drivers.filter(driver => driver.id == item.fk_driver)[0];
			this.show_modal_map_route = true;
		},

		closeMap: function() {
			this.current_delivery_route = null;
			this.current_driver_route = null;
			this.show_modal_map_route = false;
		},

		openModalStatus: function(item) {
			this.current = item;
			this.show_modal_status = true;
		},

		closeModalCargoStatus: function() {
			this.show_modal_cargo_status = false

			this.load();
		},

		closeModalStatus: function() {
			this.show_modal_status = false;
			this.current = null;
			
			this.load();
		},

		// Remove
        remove: async function(id) {
            // Apresenta a confirmação
            let confirm = await this.$alert.confirm("Deseja mesmo remover a entrega?", "REMOVER");

            // Verifica se para remover
            if(!confirm) return;
            
            // Iniciaas variáveis necessárias
            let form = {};
            form.id = id;
            let result = null;

            // Requisita a remoção
            this.loading = true;
			try {
				result = await Api.post("delivery/remove", form);
			} catch (ex) {
				console.log(ex);
				this.loading = false;
				this.$notification.error("Não foi possível remove a entrega.");
				return;
			}
            this.loading = false;
			
			if(result) {
				// Verifica se houve erro
				if(result.error) {
					this.$notification.error(result.data);
					return;
				} else {
					this.$notification.success("Entrega removida com sucesso.");

					// Recarrega a lista
					this.load();
					return;
				}
			} else {
				this.$notification.error("Não foi possível fazer a remoção.");
				return;
			}
        },

		// Remove selecionadas
        removeAll: async function() {
            // Apresenta a confirmação
            let confirm = await this.$alert.confirm("Deseja mesmo remover as entregas selecionadas?", "REMOVER");

            // Verifica se para remover
            if(!confirm) return;
            
            // Iniciaas variáveis necessárias
            let form = {
				selected: this.bulk_edit_list,
			};
            let result = null;

            // Requisita a remoção
            this.loading = true;
			try {
				result = await Api.post("delivery/remove-all", form);
			} catch (ex) {
				console.log(ex);
				this.loading = false;
				this.$notification.error("Não foi possível remover essas entregas.");
				return;
			}
            this.loading = false;
			
			if(result) {
				// Verifica se houve erro
				if(result.error) {
					this.$notification.error(result.data);
					return;
				} else {
					// Processa os retornos
					result.data.forEach(element => {
						if (element.error) {
							this.$notification.error(element.message);
						} else {
							this.$notification.success(element.message);
						}
					});

					// Recarrega a lista
					this.load();
					this.bulk_edit_list = [];
					return;
				}
			} else {
				this.$notification.error("Não foi possível fazer a remoção.");
				return;
			}
        },

		newDelivery: function() {
			this.current_form = "new";
			this.show_modal_form = true;
		},

		editDelivery: function(item) {
			this.current_form = item;
			this.show_modal_form = true;
		},

		updateFiles: function(index) {
			let new_files = [];
			this.uploading.forEach((element, pos) => {
				if (pos != index) new_files.push(element);
			});
			this.uploading = new_files;
		},
	},
}
</script>

<style scoped>
.config-tab {
	background: #d9d9d9;
	border: 1px solid #eee;
	border-bottom: none;
	padding: 10px 15px;
	margin-right: 5px;
	font-weight: bold;
}

.config-tab.enabled {
	background: #fff;
}

.container-heading {
    border: 1px solid #f0f0f0;
    border-top: none;
    background-color: #fff;
}
.container-filter {
    background-color: #f0f0f0;
}

.container-collapse-header {
    cursor: pointer;
	padding: 15px;
}

span.collapse-header-arrow {
    float: right;
}

.collapse-body {
    padding: 15px;
	border-top: 1px solid #ddd;
}

.add_new_filters {
	float: right;
	border: none;
	background: #222;
	color: #fff;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;	
    margin-top: 25px;
    width: 100%;
}

.table-container {
	background: #fff;
	padding: 15px 0;
	margin: 15px;
}

.table-container > h4 {
	padding: 0 15px;
}

.search {
	float: left;
	width: 30%;
	height: 53px;
	background: #fff;
	padding: 15px;
	border-top: 1px solid #f0f0f0;
	border-bottom: 1px solid #f0f0f0;
}

.search > label {
	font-weight: bold;
	font-size: 12px;
}

.search > input {
	width: 140px;
	height: 19px;
	margin-left: 15px;
}

.search-right {
	float: right;
	width: 70%;
	background: #fff;
	padding: 15px;
	border-top: 1px solid #f3f3f3;
	text-align: right;
}

.search-right label {
	font-weight: bold;
	font-size: 12px;
}

.search-right select {
	width: 140px;
	margin-left: 15px;
}

.delivery-filter {
	border: none;
	border-left: none;
	background: #d9d9d9;
	color: #222;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 20px;
	margin-right: 10px;
}

.delivery-filter.active {
	background: #a6a6a6;
}

.btn-delivery {
	float: right;
	margin-top: 10px;
	border: none;
	background: #d9d9d9;
	color: #000;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
	margin-left: 15px;
}

.nf-list {
	position: relative;
	height: 100%;
	overflow: hidden;
}

.nf-list-container {
	float: left;
	width: 100%;
	height: 100%;
	overflow: auto;
	padding-bottom: 15px;
}

.nf-list-item {
	width: 100%;
	float: left;
	background: #eee;
	margin-bottom: 5px;
	padding: 10px;
}


.nf-list-uploading-name {
	float: left;
	width: 80%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 14px;
	font-weight: bold;
}
.nf-list-uploading-status {
	float: left;
	width: 20%;
	font-size: 14px;
	text-align: right;
	color: #999;
}

.nf-list-result-collapse { 
	margin-top: 5px;
	margin-bottom: 5px;
}
.nf-list-result-collapse-header {
	width: 100%;
	padding-top: 5px;
	padding-bottom: 5px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 12px;
	font-weight: bold;
	cursor: pointer;
}
.nf-list-result-collapse-body {
	width: 100%;
	padding-left: 10px;
	white-space: nowrap;
	font-size: 11px;
}

.button-separator {
	float: right;
	margin-top: 10px;
	height: 34px;
	border: none;
	background: #a6a6a6;
	padding: 10px 1px;
	margin-left: 15px;
}

.no_delivery-color {
	color: #aaa;
}
.waiting-color {
	color: #555;
}
.in_progress-color {
	color: #005ef7;
}
.check_in-color {
	color: #ffb300;
}
.finished-color {
	color: #008000;
}
.failed-color {
	color: #ff0000;
}
.untracked-color {
	color: #eee;
}
</style>